import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../schema.dexie";
import type { Crianca } from "../types";
import { Icone } from "./Icone";

/**
 * Avatar do paciente: foto (Blob local) → inicial do apelido → ícone neutro.
 * Sem paciente, mostra o ícone "user" cinza-suave (estado vazio). Reaproveitável
 * em qualquer lugar que precise representar o paciente (atalho de perfil, listas…).
 */
export function PacienteAvatar({
  crianca,
  size = 38,
}: {
  crianca: Crianca | null | undefined;
  size?: number;
}) {
  const blob = useLiveQuery(
    async () => (crianca?.foto ? (await db.foto.get(crianca.foto))?.blob : undefined),
    [crianca?.foto],
  );
  const url = blob ? URL.createObjectURL(blob) : null;
  const inicial = crianca?.apelido?.trim().charAt(0).toUpperCase() || "";
  const temPaciente = Boolean(crianca);

  return (
    <span
      className={`paciente-avatar ${temPaciente ? "preenchido" : ""}`}
      style={{ width: size, height: size, fontSize: size * 0.42 }}
      aria-hidden
    >
      {url ? (
        <img src={url} alt="" onLoad={() => URL.revokeObjectURL(url)} />
      ) : inicial ? (
        <span className="pa-inicial">{inicial}</span>
      ) : (
        <span className="pa-ico">
          <Icone name="user" size={Math.round(size * 0.56)} />
        </span>
      )}
    </span>
  );
}
